export default __webpack_public_path__ + "static/media/sucess-icon.d4672811.svg";